<template>
  <div class="bg-light min-vh-100">
    <main class="container py-4">
      <div class="row justify-content-center">
        <div class="col-lg-10">
          <div class="card shadow-sm">
            <div class="card-body">
              <h1 class="h4 mb-3">Activity Log</h1>

              <!-- Filters -->
              <div class="row g-2 mb-3">
                <div class="col-md-3">
                  <label class="form-label small mb-1">User</label>
                  <input v-model="filters.user" type="text" class="form-control form-control-sm" placeholder="Username..." />
                </div>
                <div class="col-md-3">
                  <label class="form-label small mb-1">Action</label>
                  <input v-model="filters.action" type="text" class="form-control form-control-sm" placeholder="Action..." />
                </div>
                <div class="col-md-2">
                  <label class="form-label small mb-1">From</label>
                  <input v-model="filters.date_from" type="date" class="form-control form-control-sm" />
                </div>
                <div class="col-md-2">
                  <label class="form-label small mb-1">To</label>
                  <input v-model="filters.date_to" type="date" class="form-control form-control-sm" />
                </div>
                <div class="col-md-2 d-flex align-items-end">
                  <button class="btn btn-primary btn-sm w-100" @click="fetchLogs" :disabled="loading">
                    Apply
                  </button>
                </div>
              </div>

              <div v-if="loading" class="text-center py-3">
                <div class="spinner-border spinner-border-sm" role="status"></div>
              </div>

              <div v-else-if="error" class="alert alert-danger py-2">{{ error }}</div>

              <div v-else>
                <div v-if="logs.length === 0" class="text-muted">No activity logs found.</div>

                <div v-else class="table-responsive">
                  <table class="table table-sm align-middle">
                    <thead class="table-light">
                      <tr>
                        <th>Time</th>
                        <th>User</th>
                        <th>Action</th>
                        <th>Resource</th>
                        <th>Details</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="log in logs" :key="log.id">
                        <td class="small text-muted text-nowrap">{{ new Date(log.created_at).toLocaleString() }}</td>
                        <td class="small">{{ log.username || "—" }}</td>
                        <td class="small">{{ log.action }}</td>
                        <td class="small">{{ log.resource_type }}#{{ log.resource_id }}</td>
                        <td class="small">
                          <button
                            v-if="log.metadata && Object.keys(log.metadata).length"
                            class="btn btn-link btn-sm p-0"
                            @click="log._expanded = !log._expanded"
                          >
                            {{ log._expanded ? "Hide" : "Show" }}
                          </button>
                          <div v-if="log._expanded" class="mt-1">
                            <pre class="mb-0 small bg-light p-2 rounded" style="max-height: 150px; overflow: auto;">{{ JSON.stringify(log.metadata, null, 2) }}</pre>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <!-- Pagination -->
                <div class="d-flex justify-content-between align-items-center mt-2" v-if="pagination.count > 0">
                  <small class="text-muted">{{ pagination.count }} total entries</small>
                  <div class="d-flex gap-2">
                    <button
                      class="btn btn-outline-secondary btn-sm"
                      :disabled="!pagination.previous"
                      @click="goPage(currentPage - 1)"
                    >Prev</button>
                    <button
                      class="btn btn-outline-secondary btn-sm"
                      :disabled="!pagination.next"
                      @click="goPage(currentPage + 1)"
                    >Next</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import { APIService } from "../http/APIService";

export default {
  name: "ActivityLog",
  data() {
    return {
      logs: [],
      loading: false,
      error: null,
      currentPage: 1,
      pagination: { count: 0, next: null, previous: null },
      filters: {
        user: "",
        action: "",
        date_from: "",
        date_to: "",
      },
      api: new APIService(),
    };
  },
  created() {
    this.fetchLogs();
  },
  methods: {
    async fetchLogs() {
      this.loading = true;
      this.error = null;
      try {
        const accessToken = localStorage.getItem("accessToken");
        const params = { page: this.currentPage };
        if (this.filters.user) params.user = this.filters.user;
        if (this.filters.action) params.action = this.filters.action;
        if (this.filters.date_from) params.date_from = this.filters.date_from;
        if (this.filters.date_to) params.date_to = this.filters.date_to;

        const res = await this.api.getActivityLog(accessToken, params);
        const data = res.data;
        this.logs = (data.results || []).map((l) => ({ ...l, _expanded: false }));
        this.pagination = {
          count: data.count || 0,
          next: data.next,
          previous: data.previous,
        };
      } catch {
        this.error = "Unable to load activity log.";
      } finally {
        this.loading = false;
      }
    },
    goPage(page) {
      this.currentPage = page;
      this.fetchLogs();
    },
  },
};
</script>
